import { gql } from '@apollo/client'

export const GET_USER_INFO = gql`
  query UserInfo {
    userInfo {
      id
      phoneNumber
      firstName
      lastName
      mainWallet
    }
  }
`

export const IS_LOGGED_IN = gql`
  query UserSessionInfo {
    isLoggedIn @client
  }
`

export const GET_LOGIN_STATE = gql`
  query LoginState {
    loginState @client
  }
`

export const GET_STORED_USER_INFORMATION = gql`
  query getStoredUserInformation {
    userInformation @client
  }
`

export const GET_SELECTED_CONTACT = gql`
  query getSelectedContact {
    selectedContact @client
  }
`

export const GET_DATA_PRODUCT = gql`
  query GetDataProductByUserPushMoney {
    getDataProductByUserPushMoney {
      aliasId
      id
      partnerId
      producto
      valueDinammic
      voucherId
    }
  }
`
